<template>
  <svg
    width="42"
    height="19"
    viewBox="0 0 42 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      width="42"
      height="19"
      rx="9.5"
      fill="#218579"
    />
    <g filter="url(#filter0_d_17_961)">
      <circle
        cx="32.5"
        cy="9.5"
        r="7.5"
        fill="white"
      />
    </g>
    <path
      d="M8 10L11 13L17 7"
      stroke="white"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <defs>
      <filter
        id="filter0_d_17_961"
        x="25"
        y="2"
        width="15"
        height="16.9"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood
          flood-opacity="0"
          result="BackgroundImageFix"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feMorphology
          radius="4"
          operator="erode"
          in="SourceAlpha"
          result="effect1_dropShadow_17_961"
        />
        <feOffset dy="4" />
        <feGaussianBlur stdDeviation="0.95" />
        <feComposite
          in2="hardAlpha"
          operator="out"
        />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.38 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_17_961"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_17_961"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
</template>

<script>
export default {
  name: 'SwitchOnIcon',
  props: {
    customStyle: {
      type: String,
      default: 'w-16 h-12',
    },
  },
}
</script>
